<template>
  <div>
    <div class="headThem">
      云南省建设工程材料及设备信息登记卡
    </div>
    <div class="boxWrap">
      <div class="boxWrap-T">{{ company_name }}</div>
    </div>
    <div class="bodyCont">
      <div v-for="(val, ind) in li" :key="ind">
        <div class="listHead">
          <div class="listLine"></div>
          <div class="listStyle">{{ val.cate_name }}</div>
        </div>
        <ListDetailCont v-for="(val2, ind2) in val.proinfo" :key="ind2">
          <div class="listChild">
            <div class="childName">产品名称</div>
            <div class="chilDetail">{{ val2.product_name }}</div>
          </div>
          <div class="listChild">
            <div class="childName">规格型号</div>
            <div class="chilDetail">{{ val2.mspec }}</div>
          </div>
          <div class="listChild">
            <div class="childName">计量单位</div>
            <div class="chilDetail">{{ val2.munit }}</div>
          </div>
          <div class="listChild">
            <div class="childName">执行标准号</div>
            <div class="chilDetail">{{ val2.product_code }}</div>
          </div>
          <div class="listChild">
            <div class="childName">编码标识有效期</div>
            <div class="chilDetail">
              {{ val2.codetime }} 至 {{ val2.codevalidtime }}
              <span v-if="val2.has_expired == 1">
                （已过期）
              </span>
            </div>
          </div>
          <div
            @click="
              $router.push({
                name: 'qrcode',
                query: {
                  uuid: val2.attruuid
                }
              })
            "
            class="listMore"
          >
            <div class="listMore-T">查看详情</div>
            <img src="@/assets/bluearrows.png" class="blueicon" />
          </div>
        </ListDetailCont>
      </div>
      <div class="footTip">
        登记依据：《云南省住房和城乡建设厅关于做好建设工程材料设备信息登记和编码标识有关事项的通知》
      </div>
    </div>
    <!--    <div style="height: 80px;background: unset"></div>-->
    <div
      style="text-align: center; padding: 0px 0px 20px 0px;background-color: #f5f5f5;"
    >
      <el-pagination
        style="background-color: #f5f5f5;"
        background
        layout="prev, pager, next"
        :small="true"
        :total="total"
        :page-size="pageSize"
        @current-change="change"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Api from "@/plugins/axios.js";
import ListDetailCont from "@/components/ListDetailCont";

export default {
  components: {
    ListDetailCont
  },
  data() {
    return {
      company_name: null,
      currentPage: 0,
      pageSize: 15,
      total: 0,
      page: 1,
      li: []
    };
  },
  async mounted() {
    this.init();
  },
  methods: {
    change(page) {
      this.page = page;
      this.init();
    },
    async init() {
      const info = await Api.certificate(
        this.$store.state.token,
        this.$route.query.uuid,
        this.$route.query.agent_type,
        this.page
      );
      console.log(info);
      this.company_name = info.company_name;
      this.total = info.total;
      this.currentPage = info.current_page;
      this.li = info.data;
    }
  }
};
</script>
<style lang="less" scoped>
.headThem {
  height: 30px;
  background: rgba(0, 130, 164, 1);
  display: flex;
  padding: 7px 25px;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 1);
}

.boxWrap {
  background-image: url("~@/assets/heads.png");
  background-size: 100% 100%;
  height: 137px;
  background-repeat: no-repeat;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .boxWrap-T {
    padding: 0px 20px;
    font-size: 18px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}

.bodyCont {
  background-color: rgb(245, 245, 245);
  padding: 0 17px 20px 17px;
  min-height: calc(100vh - 167px);

  .footTip {
    padding: 10px;
    font-size: 13px;
    color: #666;
    line-height: 20px;
    margin-top: 20px;
    background: #fff;
  }

  .listHead {
    padding-top: 25px;
    display: flex;
    align-items: center;

    .listStyle {
      font-size: 16px;
      font-weight: bold;
      color: rgba(13, 86, 129, 1);
    }

    .listLine {
      width: 2px;
      height: 20px;
      background: rgba(13, 86, 129, 1);
      margin-right: 10px;
    }
  }
}

.listChild {
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid rgba(230, 230, 230, 1);

  .childName {
    font-size: 13px;
    min-width: 80px;
    text-align: left;
    font-weight: 400;
    line-height: 35px;
    color: rgba(0, 130, 164, 1);
  }

  .chilDetail {
    margin-left: 20px;
    font-size: 13px;
    font-weight: 400;
    line-height: 35px;
    color: rgba(51, 51, 51, 1);
  }
}

.listMore {
  display: flex;
  justify-content: center;
  align-items: center;

  .blueicon {
    width: 7px;
    height: 12px;
    margin-left: 10px;
  }

  .listMore-T {
    font-size: 12px;
    font-weight: 400;
    line-height: 31px;
    color: rgba(0, 177, 255, 1);
  }
}
</style>
